module.exports = __webpack_public_path__ + "static/media/DC_F_Timeless_Sforza_White.217520a7.png";